import Vue from 'vue'
import VueRouter from 'vue-router'
import {
  Home,
  ComponentDemo,
  About,
  Projects,
  ProjectsSingle,
  Resources,
  ResourcesResearch,
  ResourcesNcf,
  ResourcesTraining,
  ResourcesMonitoring,
  ResourcesMonitoringSingle,
  Events,
  EventsIndex,
  EventsSingle,
  Donation,
  Register,
  AboutTeam,
  AboutHistory,
  AboutMembers,
  AboutCollaborations,
  AboutCommittees,
  Partners,
  Credits,
  Policy,
  Writing,
  Contact,
  Publications,
  PublicationSingle,
  News,
  NewsSingle,
  Search,
  Accessibility
} from '@/views'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  linkActiveClass: '-active',
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) return { selector: to.hash, offset: { x: 0, y: 150 } }
    const position = to.name !== from.name ? { x: 0, y: 0 } : false
    return savedPosition || position
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/a-propos',
      name: 'about',
      component: About
    },
    {
      path: '/a-propos/equipe',
      name: 'about-team',
      meta: { parents: ['about'] },
      component: AboutTeam
    },
    {
      path: '/a-propos/historique',
      name: 'about-history',
      meta: { parents: ['about'] },
      component: AboutHistory
    },
    {
      path: '/a-propos/membres',
      name: 'about-members',
      meta: { parents: ['about'] },
      component: AboutMembers
    },
    {
      path: '/a-propos/membres/devenir-membre',
      name: 'about-members-register',
      meta: { parents: ['about', 'about-members'] },
      component: Register
    },
    {
      path: '/a-propos/collaborations',
      name: 'about-collaborations',
      meta: { parents: ['about'] },
      component: AboutCollaborations
    },
    {
      path: '/a-propos/documents-institutionnels',
      name: 'about-documentation',
      meta: { parents: ['about'] },
      component: Home
    },
    {
      path: '/a-propos/instances-et-comites',
      name: 'about-committees',
      meta: { parents: ['about'] },
      component: AboutCommittees
    },
    {
      path: '/evenements',
      name: 'events',
      component: Events
    },
    {
      path: '/evenements/index',
      name: 'event-index',
      meta: { parents: ['events'] },
      component: EventsIndex
    },
    {
      path: '/evenements/index/:eventSlug',
      name: 'event-single',
      meta: { parents: ['events', 'event-index'] },
      props: true,
      component: EventsSingle
    },
    {
      path: '/projets',
      name: 'project-index',
      component: Projects
    },
    {
      path: '/projets/:projectSlug',
      name: 'project-single',
      meta: { parents: ['project-index'] },
      props: true,
      component: ProjectsSingle
    },
    {
      path: '/publications',
      name: 'publication-index',
      component: Publications
    },
    {
      path: '/publications/:publicationSlug',
      name: 'publication-single',
      meta: { parents: ['publication-index'] },
      props: true,
      component: PublicationSingle
    },
    {
      path: '/nouvelles',
      name: 'news-index',
      component: News
    },
    {
      path: '/nouvelles/:newsSlug',
      name: 'news-single',
      meta: { parents: ['news-index'] },
      props: true,
      component: NewsSingle
    },
    {
      path: '/outils',
      name: 'resources-index',
      component: Resources
    },
    {
      path: '/outils/services-de-recherche',
      name: 'resources-research',
      meta: { parents: ['resources-index'] },
      component: ResourcesResearch
    },
    {
      path: '/outils/nos-competences-fortes',
      name: 'resources-ncf',
      meta: { parents: ['resources-index'] },
      component: ResourcesNcf
    },
    {
      path: '/outils/trucs-et-outils',
      name: 'resources-training',
      meta: { parents: ['resources-index'] },
      component: ResourcesTraining
    },
    {
      path: '/outils/veille-informationnelle',
      name: 'resources-monitoring',
      meta: { parents: ['resources-index'] },
      component: ResourcesMonitoring
    },
    {
      path: '/outils/veille-informationnelle/:monitoringSlug',
      name: 'resources-monitoring-single',
      meta: { parents: ['resources-index', 'resources-monitoring'] },
      props: true,
      component: ResourcesMonitoringSingle
    },
    {
      path: '/recherche',
      name: 'search',
      component: Search
    },
    {
      path: '/dons',
      name: 'donation',
      component: Donation
    },
    {
      path: '/partenaires',
      name: 'partners',
      component: Partners
    },
    {
      path: '/contact',
      name: 'contact',
      component: Contact
    },
    {
      path: '/politique-de-confidentialite',
      name: 'policy',
      component: Policy
    },
    {
      path: '/politique-de-redaction',
      name: 'writing',
      component: Writing
    },
    {
      path: '/credits',
      name: 'credits',
      component: Credits
    },
    {
      path: '/accessibilite',
      name: 'accessibility',
      component: Accessibility
    },
    {
      path: '/design-demo',
      name: 'component-demo',
      component: ComponentDemo
    }
  ]
})

export default router
